export default function Solution() {
  return (
    <section id="solution" className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-violet-600/5 to-transparent"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-violet-600/10 border border-violet-500/30 rounded-full mb-6">
              <span className="text-sm text-violet-300 whitespace-nowrap">La Solution</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Un bras droit stratégique
              <br />
              <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
                qui ne dort jamais
              </span>
            </h2>

            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              AI Exécutif Assistant est une solution d'assistanat exécutif basée sur l'intelligence artificielle, conçue pour accompagner les dirigeants dans la gestion quotidienne de leurs opérations, communications et priorités.
            </p>

            <p className="text-base text-gray-400 mb-6 leading-relaxed">
              Notre assistant agit comme un bras droit stratégique, capable d'automatiser les tâches chronophages à faible valeur ajoutée, tout en garantissant une exécution continue, fiable et confidentielle.
            </p>

            <p className="text-base text-gray-400 mb-8 leading-relaxed">
              Entièrement personnalisé selon votre organisation, il s'intègre à vos outils existants (emails, agenda, messageries, CRM) et fonctionne 24/7, sans interruption.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center bg-violet-600/20 rounded-full mt-1 flex-shrink-0">
                  <i className="ri-check-line text-sm text-violet-400"></i>
                </div>
                <p className="text-gray-300">Libérez du temps de décision et réduisez la charge mentale</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center bg-violet-600/20 rounded-full mt-1 flex-shrink-0">
                  <i className="ri-check-line text-sm text-violet-400"></i>
                </div>
                <p className="text-gray-300">Sécurisez votre organisation avec un contrôle total</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center bg-violet-600/20 rounded-full mt-1 flex-shrink-0">
                  <i className="ri-check-line text-sm text-violet-400"></i>
                </div>
                <p className="text-gray-300">Exécution continue, fiable et confidentielle</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-violet-600/10 to-blue-600/10 border border-violet-500/30 rounded-lg p-6">
              <p className="text-lg font-semibold text-white text-center leading-relaxed">
                Une seule solution. Une disponibilité totale. Une exécution sans faille.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-violet-600/20 to-blue-600/20 rounded-2xl blur-3xl"></div>
            <div className="relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-8">
              <img 
                src="https://public.readdy.ai/ai/img_res/8d58d225266af6909688c39e4bdcf14f.jpg" 
                alt="AI Assistant Interface" 
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}